import { EXPORTED_PAYOUTS_MODAL_TEST_ID } from '../../constants';

type Props = {
  createdAfter: string;
  createdBefore: string;
  virtualAccountNumber: string;
  stateCategories: string[];
};

export const DownloadPayoutRequestsCard = ({
  createdAfter,
  createdBefore,
  virtualAccountNumber,
  stateCategories
}: Props) => {
  return (
    <div
      className="flex flex-col space-y-2 bg-surface-muted p-3"
      data-testid={EXPORTED_PAYOUTS_MODAL_TEST_ID}
    >
      <div>
        <div>Date range:</div>
        <div className="font-semibold">
          From {createdAfter} To {createdBefore}
        </div>
      </div>
      <div>
        <div>Account:</div>
        <div className="font-semibold">{virtualAccountNumber}</div>
      </div>
      {stateCategories && stateCategories.length > 0 && (
        <div>
          <div>Status:</div>
          <div className="font-semibold first-letter:capitalize">
            {stateCategories}
          </div>
        </div>
      )}
    </div>
  );
};
